import React, { useEffect } from 'react';

import { CommonError } from 'src/components/common-error';
import { clockImageProps } from 'src/resources/images';
import { startAuthenticationActionCreator } from 'src/state/auth/action-creators/start-authentication-action-creator';
import { resetStateActionCreator } from 'src/state/common/reset-state-action-creator';
import { useAppDispatch } from 'src/state/thunk-api';
import { i18n } from 'src/i18n';

export const PageSessionsExpired = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(resetStateActionCreator());
  }, [dispatch]);

  const handleLogin = () => {
    dispatch(startAuthenticationActionCreator());
  };

  return (
    <CommonError
      title={i18n.page.error.sessionExpired.title}
      subtitle={[i18n.page.error.sessionExpired.sessionHasExpired, i18n.page.error.sessionExpired.loginAgain]}
      buttonText={i18n.page.error.sessionExpired.login}
      hideCustomerServiceText={true}
      onButtonClick={handleLogin}
      image={clockImageProps}
    />
  );
};
